import { forwardRef } from 'react';
import Axis, { METRIC_ORIENTATION } from '../../../common/d3/Axis';

export const AxisGrid = forwardRef<
  SVGGElement,
  {
    primaryPlotGetMetricOrientation;
    primaryPlotGetYScale;
    secondaryPlotGetYScale;
    primaryPlotGetXScale;
    numTicks;
    isMobile;
    primaryYAxisEnabled;
    secondaryYAxisEnabled;
    chartWidth;
  }
>(
  (
    {
      primaryPlotGetMetricOrientation,
      primaryPlotGetYScale,
      secondaryPlotGetYScale,
      primaryPlotGetXScale,
      numTicks,
      isMobile,
      primaryYAxisEnabled,
      secondaryYAxisEnabled,
      chartWidth,
    },
    forwardingRef,
  ) => {
    const isVertical =
      primaryPlotGetMetricOrientation() === METRIC_ORIENTATION.VERTICAL;
    if (!primaryYAxisEnabled() && !secondaryYAxisEnabled()) {
      return null;
    }
    const scale = isVertical
      ? primaryYAxisEnabled()
        ? primaryPlotGetYScale()
        : secondaryPlotGetYScale()
      : primaryPlotGetXScale();
    const yGridProps = {
      scale,
      ticks: numTicks,
      orient: isVertical ? 'grid' : 'grid-horizontal',
      tickFormat: '',
      tickSizeInner: -chartWidth,
      scrollable: 'true',
      isMobile,
    };
    return <Axis resizeRef={forwardingRef} {...yGridProps} />;
  },
);
